// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__6PYQk","tag__title":"Tag_tag__title__zxVmD","tag__text":"Tag_tag__text__q6dC7","tag__text_2":"Tag_tag__text_2__X9MJN"};